// extracted by mini-css-extract-plugin
export default {"alertp":"NeonDodge3D_alertp__niUlE"};